// extracted by mini-css-extract-plugin
export default {"mainBlock":"card_mainBlock__JixBH","titleBlock":"card_titleBlock__vJDJx"};